import React from 'react';
import PropTypes from 'prop-types';
import { withSnackbar } from 'notistack';
import { PermPhoneMsg as PermPhoneMsgIcon } from '@material-ui/icons';
import { withStyles, Grid, FormControl, InputBase, Typography, Button, CircularProgress } from '@material-ui/core';

import { doNotification } from '../../../shared/component/notifier';

const styles = theme => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    margin: {
        marginTop: theme.spacing(1),
    },
    txtSm: {
        fontSize: '0.8rem',
        color: theme.palette.grey[500],
    },
    txtCounter: {
        color: "#01425E",
        fontWeight: 500
    },
    txtHeader: {
        color: theme.palette.grey[500],
        fontSize: '0.875rem'
    },
    icon: {
        fontSize: 45,
        borderRadius: '50%',
        padding: theme.spacing(1),
        marginBottom: theme.spacing(1),
        color: theme.palette.grey[500],
        background: theme.palette.grey[200],
    },
});

const CustomInput = withStyles((theme) => ({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
        letterSpacing: '23px',
        textAlign: 'center',
        borderStyle: 'dashed',
        borderRadius: 4,
        border: '1px solid #eeeeee',
        position: 'relative',
        fontSize: 24,
        fontWeight: 700,
        color: theme.palette.grey[700],
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderColor: '#9e9e9e',
        },
    },
}))(InputBase);

class OneTimePasswordForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            formData: {
                otp: "",
            },
            minutes: 1,
            seconds: 0,
            submitDisabled: true,
            resendDisabled: true,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleResendOtp = this.handleResendOtp.bind(this);
    }

    componentDidMount() {
        this.handleCountDownTimer();
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    handleChange(event) {
        const { formData, submitDisabled } = this.state;
        const { name, value } = event.target;

        if (value.length > 6) {
            event.preventDefault();
            return;
        }
        if (value.length === 6) {
            this.setState({submitDisabled: false})
        }
        if (value.length !==6 && !submitDisabled ) {
            this.setState({submitDisabled: true})
        }
        formData[name] = value;
        this.setState({ formData });
    }

    handleSubmit(event) {
        event.preventDefault();
        const { verifyAction } = this.props;
        const { formData } = this.state;

        if (!formData.otp) {
            this.alertMessage('Please enter OTP');
            return;
        }
        verifyAction(formData);
    }

    handleCountDownTimer() {
        setTimeout(() => this.countdownTimer(), 2000)
    }

    handleResendOtp() {
        const { resendAction } = this.props;

        clearInterval(this.timer);
        resendAction();

        this.setState({
            formData: {otp: ""},
            minutes: 1,
            seconds: 0,
            submitDisabled: true,
            resendDisabled: true,
         }, this.handleCountDownTimer);
    }

    alertMessage(message, variant='default') {
        const { enqueueSnackbar, closeSnackbar } = this.props;
        this.notify = doNotification(enqueueSnackbar, closeSnackbar, message, variant);
    }

    countdownTimer() {
        this.timer = setInterval(() => {
            const { seconds, minutes } = this.state;

            if (seconds > 0) {
                this.setState(state => ({ seconds: state.seconds - 1 }))
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    this.setState({ resendDisabled: false });
                    clearInterval(this.timer);
                    return;
                }
                this.setState(state => ({
                    minutes: state.minutes - 1,
                    seconds: 59
                }))
            }
        }, 1000)
    }

    render () {
        const { classes, isLoading } = this.props;
        const { formData, minutes, seconds, submitDisabled, resendDisabled } = this.state;

        return(
            <React.Fragment>
                <form noValidate onSubmit={this.handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid item container justify="center">
                                <PermPhoneMsgIcon className={classes.icon}/>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid item container spacing={1}>
                                <Grid item xs={12}>
                                    <Typography component="div" align="center" className={classes.txtHeader}>
                                        A one time password has been sent to your mobile.
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography component="div" align="center" className={classes.txtCounter}>
                                        { minutes }:{ seconds < 10 ? `0${ seconds }` : seconds }
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid item container justify="center" spacing={1}>
                                <Grid item container justify="center" md={9} xs={12}>
                                    <FormControl className={classes.margin}>
                                        <CustomInput
                                            autoFocus
                                            autoComplete="off"
                                            id="custom-input"
                                            name="otp"
                                            type="number"
                                            value={formData.otp}
                                            onChange={this.handleChange}
                                            inputProps={{
                                                maxLength: 6,

                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography component="div" align="center" className={classes.txtSm}>
                                        Did not receive the OTP?
                                        <Button
                                            color="secondary"
                                            className="btn"
                                            onClick={this.handleResendOtp}
                                            disabled={resendDisabled}
                                        >
                                            Resend
                                        </Button>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container justify="center">
                                <Grid item md={9} sm={6} xs={6}>
                                    {submitDisabled ? (
                                        <Button fullWidth className="btn" color="secondary" variant="contained" style={{ backgroundColor: '#01425EBF', pointerEvents: 'none '}}>
                                            Verify
                                        </Button>
                                    ) : (
                                        <Button fullWidth type="submit" className="dark_blue_btn btn" color="secondary" variant="contained">
                                            {isLoading ? <CircularProgress size={24} style={{ color: "#FFF" }} />: 'Verify'}
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </React.Fragment>
        )
    }
}

OneTimePasswordForm.propTypes = {
    isLoading: PropTypes.bool,
    verifyAction: PropTypes.func,
    resendAction: PropTypes.func
};

export default withSnackbar(withStyles(styles)(OneTimePasswordForm));

